'use strict';

var _ = require('underscore');

/**
 * Listens to `transitionend` event on component's DOM node.
 * Calls `handleTransitionEnd` when transitionend occurs.
 */
var TransitionEventsMixin = {
  componentDidMount: function () {
    if (!_.isFunction(this.handleTransitionEnd)) {
      throw new Error('Define handleTransitionEnd to listen to transition events.');
    }

    this._bindTransitionEvents();
  },

  componentWillUpdate: function () {
    this._unbindTransitionEvents();
  },

  componentDidUpdate: function () {
    this._bindTransitionEvents();
  },

  componentWillUnmount: function () {
    this._unbindTransitionEvents();
  },

  _bindTransitionEvents: function () {
    if (!this.isMounted()) {
      return;
    }

    var node = this.getDOMNode();
    node.addEventListener('transitionend', this._handleTransitionEnd);
    node.addEventListener('webkitTransitionEnd', this._handleTransitionEnd);
  },

  _unbindTransitionEvents: function () {
    if (!this.isMounted()) {
      return;
    }

    var node = this.getDOMNode();
    node.removeEventListener('transitionend', this._handleTransitionEnd);
    node.removeEventListener('webkitTransitionEnd', this._handleTransitionEnd);
  },

  _handleTransitionEnd(e) {
    if (!this.isMounted()) {
      return;
    }

    if (e.target === e.currentTarget) {
      this.handleTransitionEnd(e);
    }
  },

  _withDOMNode: function (action) {
    if (this.isMounted()) {
      action.call(this, this.getDOMNode());
    }
  }
};

module.exports = TransitionEventsMixin;


/** WEBPACK FOOTER **
 ** ./mixins/TransitionEventsMixin.js
 **/